/**
 * Configurations — placeholder page.
 *
 * Wired into the admin SPA at /setup/configurations with a SUPER_ADMIN
 * gate so the route is reachable today. The actual configurations view
 * (feature flags, system-wide defaults, integration toggles) is
 * intentionally deferred — this page exists to anchor the Setup group's
 * Configurations entry and reserve the URL.
 */
import React from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { SecurityBoundary } from '@vehix/portal/lib/security';
import { SystemRole } from '@vehix/portal/types';

const ConfigurationsPage: React.FC = () => {
  return (
    <SecurityBoundary
      requiredSystemRole={SystemRole.SUPER_ADMIN}
      auditPageAccess='setup-configurations'
      tenantIsolation={false}
    >
      <div className='flex h-full w-full items-center justify-center p-8'>
        <div className='max-w-md text-center space-y-4'>
          <div className='mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-muted'>
            <SlidersHorizontal className='h-8 w-8 text-muted-foreground' />
          </div>
          <h1 className='text-2xl font-bold tracking-tight'>Configurations</h1>
          <p className='text-sm text-muted-foreground'>
            Coming soon. This page will house system-wide configuration:
            feature flags, integration toggles, and platform-level defaults.
          </p>
        </div>
      </div>
    </SecurityBoundary>
  );
};

export default ConfigurationsPage;
